import { factory } from '../../utils/apiThunkFactory.js';

export const uploadMessageFile = factory.post("messageHistory/uploadMessageFile", "/api/messages/upload-file");


export const getConversationPreviews = factory.get('messageHistory/getConversationPreviews', '/api/messages/conversations/preview');
export const getMessagesByConversation = factory.get(
  'messageHistory/getMessagesByConversation', '/api/messages/getMessages/:conversationId'
);
export const getUnreadConversationCount = factory.get('messageHistory/getUnreadConversationCount', '/api/messages/unreadCount');
export const getMessagesPaged = factory.get("messageHistory/getMessagesPaged", "/api/messages/paged/:conversationId");
export const getUnreadMessagesByConversation = factory.get("messageHistory/getUnreadMessagesByConversation", "/api/messages/unreadMessages");
export const searchMessagesPaged = factory.get("messageHistory/searchMessagesPaged", "/api/messages/search/:conversationId");
export const mirrorDmToMattermost = factory.post("messageHistory/mirrorDmToMattermost","/api/mattermost/dm/mirror-with-pat/:tenantId");
